<template>
	<div>
		<article v-if="routeItems.length === 0" class="message is-info">
			<div class="message-body has-text-centered">
				<span v-if="sectorId == 0">{{ app.Language.get('tours.route.list.choose_sector_for_objects_adding') }}</span>
				<span v-else-if="sectorId > 0">{{ app.Language.get('tours.route.list.choose_objects_for_route_creation') }}</span>
			</div>
		</article>
		<div v-else v-draggable="routeItems" :key="renderKey" class="route-items">
			<RouteItem
				v-bind:app="app"
				v-for="(item, index) in routeItems"
				v-bind:item="item"
				v-bind:key="item.key"
				v-bind:routeObjects="routeObjects"
				v-bind:openRoutePath="openRoutePath"
				v-bind:playerState="playerState"
				v-on="$listeners"></RouteItem>
		</div>
	</div>
</template>

<script>
  	import Vue from 'vue';
  	import Sortable from 'sortablejs';
	import { reorderArray, toHumanTime } from '../../Helpers';

	const routePathLoaderPlaceholder = '<div class="route-item is-route-path is-loading"></div>';

    Vue.directive('draggable', {
      //adapted from https://codepen.io/kminek/pen/pEdmoo
      inserted: function(el, binding, vnode) {
        Sortable.create(el, {
          sort: true,
          filter: '.is-route-path',
          animation: 150,
          swapThreshold: 0.90,
          direction: 'horizontal',
          chosenClass: 'animated-background',
          onEnd: function(e) {

            let items = reorderArray(vnode.context[binding.expression], e.oldIndex, e.newIndex).filter((item) => {
              return item.type !== 'path'
            });

            Vue.nextTick(function() {
              vnode.context.reorder(items);
            });

          },
          onMove: function (/**Event*/evt, /**Event*/originalEvent) {

			let draggedItem = $(evt.dragged),
				relatedItem = $(evt.related),
			  	isEquals = (
			  	  draggedItem.prev().get(0) === relatedItem.get(0)
				  || draggedItem.next().get(0) === relatedItem.get(0)
				);

			// Если соседние объекты являются соседями перетаскиваемого с любой из сторон,
			// то запрет на перемещение
			if (isEquals) {
			  return false;
			}

          },
          onChange: function(/**Event*/evt) {

            let currentItem = $(evt.item),
              	prevItem = currentItem.prev(),
              	nextItem = currentItem.next(),
              	siblings = currentItem.siblings();

			// Удаляется первый и последний элемент, если они являются маршрутами (из ниоткуда/в никуда)
            siblings.first().filter('.is-route-path').remove();
            siblings.last().filter('.is-route-path').remove();

            // Добавляется лоадер пути, если между текущим и следующим объектом нет пути
			if (nextItem.hasClass('is-route-object')) {
			  nextItem.before(routePathLoaderPlaceholder);
			}
			// Заменяется на лоадер пути маршрут, идущий на текущим объектом
            if (nextItem.hasClass('is-route-path')) {
              nextItem.replaceWith(routePathLoaderPlaceholder);
            }

            // Добавляется лоадер пути, если между текущим и предыдущим объектом нет пути
			if (prevItem.hasClass('is-route-object')) {
              prevItem.after(routePathLoaderPlaceholder);
			}
            // Заменяется на лоадер пути маршрут, идущий перед текущим объектом
            if (prevItem.hasClass('is-route-path')) {
              prevItem.replaceWith(routePathLoaderPlaceholder);
            }

			// Удаляются двойные пути (идущие друг за другом) и заменяется на один лоадер пути
			$('.is-route-path + .is-route-path').each((index, element) => {
			  $(element).prev().remove();
			  $(element).replaceWith(routePathLoaderPlaceholder);
			});

            /**
            if (currentItem.hasClass('is-route-path') && nextItem.hasClass('is-route-path')) {
              currentItem.remove();
            } **/

          }
        });
      }
    });

    export default {
      components: {
        RouteItem: () => import ('./RouteItem')
      },
      props: {
        rand:     Number,
        app:      Object,
        sectorId: Number,
        routeObjects:  Array,
        routePaths:    Object,
        getRoutePathKey: Function,
        openRoutePath: Function,
        closeRoutePath: Function,
		reorder:  Function,
        playerState: Object
      },
      watch: {
        routeObjects: {
          handler: function () {

            this.forceRerender();
          },
          immediate: true,
        },
        routePaths: {
          handler: function () {
            this.$forceUpdate();
          },
          immediate: true,
        },
        sectorId: {
          handler: function () {
            this.$forceUpdate();
          },
          immediate: true,
        },
      },
      data () {
        return {
          renderKey: 0
		}
      },
      computed: {
        routeItems() {
			let objects = this.routeObjects,
				items = [];

			let index = 0;
			for(let i = 0; i < objects.length; i++) {

			  // Create path
              if (i > 0 && (i - 1) <= objects.length) {
                let currentRouteObject = objects[i],
                  	previousRouteObject = objects[i-1],
                  	key = this.getRoutePathKey(previousRouteObject, currentRouteObject);

                items.push(this.getRoutePath(key));
              }

			  // Add object
              let object = objects[i];
			  object.key = `object-${object.id}`;
			  items.push(object);

			}

			return items;
        }
	  },
      updated: function () {
      },
	  methods: {
        toHumanTime(value) {
          return toHumanTime(value);
        },
        forceRerender() {
          this.renderKey += 1;
        },
        getRoutePath(key) {
          return this.routePaths[key];
        },
		/*
		reorder(value) {
          this.$parent.$emit('reorder', value);
        }*/
	  }
    }
</script>